import React from 'react';
import { TEAM_LOGOS } from '../../assets/logos';

interface TeamLogoProps {
  team: string;
  league: string;
  size?: 'sm' | 'md' | 'lg';
}

export const teamAbbr = (team: string, league: string): string => {
  const known = TEAM_LOGOS[league]?.[team]?.abbr;
  if (known) return known;
  const words = team.replace(/[^\p{L}\p{N} ]/gu, ' ').split(/\s+/).filter(Boolean);
  if (words.length === 1) return words[0].slice(0, 3).toUpperCase();
  return words.slice(0, 3).map((w) => w[0]).join('').toUpperCase();
};

const TeamLogo: React.FC<TeamLogoProps> = ({ team, league, size = 'md' }) => {
  const logo = TEAM_LOGOS[league]?.[team];
  return (
    <span className={`team-logo team-logo--${size}`}>
      {logo ? (
        <img className="team-logo__img" src={logo.src} alt={team} loading="lazy" decoding="async" />
      ) : (
        <span className="team-logo__fallback" aria-label={team}>
          {teamAbbr(team, league)}
        </span>
      )}
    </span>
  );
};

export default TeamLogo;
